import { LGraphNode, LiteGraph } from "litegraph.js";
import { addDrivableSlider, finalizeDrivableSliders, syncDrivableSliders } from "../utils/addDrivableSlider.js";

/**
 * RandomNode
 * ----------
 * Outputs random values. Can be continuous (new value every frame)
 * or triggered (new value on change/interval).
 */
export class RandomNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Random";

    this.properties = {
      min: 0,
      max: 1,
      mode: "continuous",
      interval: 30,
    };

    this._value = 0;
    this._counter = 0;

    this.addOutput("Value", "number");

    this.addWidget("combo", "Mode", "continuous", (val) => {
      this.properties.mode = val;
    }, { values: ["continuous", "interval", "smooth"] });

    addDrivableSlider(this, "Min", "min", 0, -500, 500, 0.1);
    addDrivableSlider(this, "Max", "max", 1, -500, 500, 0.1);
    addDrivableSlider(this, "Interval", "interval", 30, 1, 120, 1);

    finalizeDrivableSliders(this, 0);

    this._targetValue = 0;

    this.size = [200, 120];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  onDrawForeground(ctx) {
    const w = this.size[0];
    const h = this.size[1];

    ctx.fillStyle = "rgba(255,255,255,0.4)";
    ctx.font = "bold 12px monospace";
    ctx.textAlign = "center";
    ctx.fillText(this._value.toFixed(2), w / 2, h - 8);
    ctx.textAlign = "left";
  }

  _newRandom() {
    const { min, max } = this.properties;
    return min + Math.random() * (max - min);
  }

  onExecute() {
    syncDrivableSliders(this);

    const { mode, interval } = this.properties;

    if (mode === "continuous") {
      this._value = this._newRandom();
    } else if (mode === "interval") {
      this._counter++;
      if (this._counter >= interval) {
        this._counter = 0;
        this._value = this._newRandom();
      }
    } else if (mode === "smooth") {
      this._counter++;
      if (this._counter >= interval) {
        this._counter = 0;
        this._targetValue = this._newRandom();
      }
      // Smooth interpolation toward target
      this._value += (this._targetValue - this._value) * 0.1;
    }

    this.setOutputData(0, this._value);
  }
}

LiteGraph.registerNodeType("generators/Random", RandomNode);
